module.exports = __webpack_public_path__ + "img/appstore-badge.8b39bfef.png";